import service from '@/request/config/axios'
import ApiPrefix from '@/request/config/prefix'

/** 下载中心 */
const downloadService = {
  getDownloadList: (data) =>
    service(`${ApiPrefix.COMMUNITY}/community/media/jobInfo/list`, {
      method: 'post',
      data,
    }),

  // Old synchronous API (keep for backward compatibility if needed)
  updateUrl: (data) =>
    service(`${ApiPrefix.COMMUNITY}/community/media/jobInfo/generateUrl`, {
      method: 'post',
      data,
      responseType: 'blob',
      timeout: 600000,
      headers: {
        Accept: 'application/octet-stream',
      },
    }),

  // NEW: Submit async watermark job
  submitWatermarkJob: (data) =>
    service(
      `${ApiPrefix.COMMUNITY}/community/media/jobInfo/submitWatermarkJob`,
      {
        method: 'post',
        data,
      }
    ),

  // NEW: Get watermark job status
  getWatermarkJobStatus: (jobId) =>
    service(
      `${ApiPrefix.COMMUNITY}/community/media/jobInfo/watermarkStatus/${jobId}`,
      {
        method: 'get',
      }
    ),

  // NEW: Download watermarked file
  downloadWatermarkedFile: (jobId) =>
    service(
      `${ApiPrefix.COMMUNITY}/community/media/jobInfo/download/${jobId}`,
      {
        method: 'get',
        responseType: 'blob',
        timeout: 60000,
        headers: {
          Accept: 'application/octet-stream',
        },
      }
    ),

  addCount: (data) =>
    service(`${ApiPrefix.COMMUNITY}/community/media/jobInfo/addCount`, {
      method: 'post',
      data,
    }),

  deleteJob: (data) =>
    service(`${ApiPrefix.COMMUNITY}/community/media/jobInfo/delete`, {
      method: 'post',
      data,
    }),
}

export default downloadService
